<template>
  <div class="wall-surface-area__table-wrap">
    <!-- header-row -->
    <!-- <div class="surface-area__table-header-row">
      <div class="table-headers">ORIENTATION</div>
      <div class="table-headers">WWR orientation-wise (Glass + Frame)		
</div>
      <div class="table-headers">Opening Area(sq M)</div>
    </div> -->
    <!-- data-rows -->
    <div class="window-glass-rows-3B">
      <div v-for="(window, i) in step3B.windowTypeArrObj" :key="i" class="window-glass-columns-3B">
        <div style="text-align:center">{{ window.window_serial }}</div>
        <!-- <div class="window-glass__type">0 %</div> -->
        <div class="window-glass__type" style="width:80%">
          <hr />
          <v-text-field outlined dense type="number" suffix="%" v-model="window.input_glass_percent" placeholder="Ente "></v-text-field>

          <!-- <LvInput v-model="window.input_glass_percent" /> -->
          <!-- <hr /> -->
        </div>
        <template v-for="(orient, k) in window.orientationObj">
          <div v-if="orient.calcGlassArea" class="step3B-window-glass-data-col" style="width:70%">
            <div class="step3B__window-glass-orientation">
              <span class="orientation"> {{ orient.orientation }}</span>
            </div>
            <span class="orientation-percentage">{{ orient.calcGlassArea }}</span>
          </div>
        </template>
      </div>
    </div>
    <hr />
    <div class="step-3B__summary">
      <div class="summary-head">Summary:</div>
      <div class="summary-block__wrap">
        <div class="summary-field__row" v-for="(window, m) in step3B.windowTypeArrObj">
          <div class="sumarry-field__label">{{ window.window_serial }} Total glass area :<span class="units">(sq.M)</span></div>
          <div class="summary-field__value">{{ window.all_orient_glass_area }}</div>
        </div>

        <hr />
        <div class="summary-field__row">
          <div class="sumarry-field__label">Overall glass area of all window:<span class="units">(sq.M)</span></div>
          <div class="summary-field__value">{{ step3B.summary_window_glass.total_glass_area }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LvInput from 'lightvue/input';
import LvDropdown from 'lightvue/dropdown';
export default {
  components: {
    LvInput,
    LvDropdown,
  },
  data() {
    return {};
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step3B: {
      get: function() {
        return this.$store.state.schema.inputs.step3B;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3B', step3B);
      },
    },
  },
  beforeUpdate() {
    this.calculateGlassArea();
  },
  methods: {
    calculateGlassArea() {
      let totalGlassArea = 0;
      for (let j = 0; j <= this.step3B.windowTypeArrObj.length - 1; j++) {
        let allOrientGlassArea = 0;

        for (let k = 0; k <= this.step3B.wwrWindowArrObj.length - 1; k++) {
          // calculation of glass area for each orientation i.e [windowType.openablePercent*inputGlassPercent*openingArea of each orient]
          this.step3B.windowTypeArrObj[j].orientationObj[k].calcGlassArea = +(+this.step3B.windowTypeArrObj[j].input_glass_percent * +0.01 * +this.step3B.windowTypeArrObj[j].orientationObj[k].inputOrientationPercent * 0.01 * +this.step3B.wwrWindowArrObj[k].calcWindowOpeningArea).toFixed(2);
          //  calculation for sum of openable area of all orientations for each window
          allOrientGlassArea = +allOrientGlassArea + +this.step3B.windowTypeArrObj[j].orientationObj[k].calcGlassArea;
        }
        //  calculation for total openable area of all windows
        this.step3B.windowTypeArrObj[j].all_orient_glass_area = allOrientGlassArea;
        totalGlassArea = +totalGlassArea + allOrientGlassArea;
        //calc of opaque percent for each window
        this.step3B.windowTypeArrObj[j].opaque_percent = 100 - this.step3B.windowTypeArrObj[j].input_glass_percent;
      }
      this.step3B.summary_window_glass.total_glass_area = totalGlassArea.toFixed(2);
      // this.step3B.summary_window_openable.total_openable_area = this.step3B.windowTypeArrObj[j].all_orient_openable_area + this.step3B.summary_window_openable.total_openable_area;
    },
  },
};
</script>

<style lang="scss">
.surface-area__table-header-row {
  display: flex;
  width: 100%;
  background-color: #dedede;
  margin-top: 12px;
  .table-headers {
    color: #343f4b;
    padding: 12px;
    font-size: 16px;
    width: 33.33%;
  }
}

.window-glass-rows-3B {
  padding: 12px 4px 4px 4px;
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: auto;
  justify-content: space-around;
  .window-glass-columns-3B {
    display: flex;
    flex-direction: column;
    //    align-self: unset;
    width: 20%;
    .window-glass__type {
      height: 42px;
      //   display: flex;
      //   flex-direction: column;
      //   justify-content: center;
      //   align-items: center;
      // width: 20%;
      align-self: unset;
    }
  }
}

.step3B-window-glass-data-col {
  margin-top: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  // width: 98px;

  .orientation-percentage {
    width: 64px;

    padding: 6px;
    background-color: #dedede;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.step3B__window-glass-orientation {
  width: 84%;
  // width: 98px;

  margin: 4px 0px;
  background-color: #dedede;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  display: flex;

  .orientation {
    width: 36px;
    padding: 6px;
    color: #fff;
    // text-align: center;
    justify-content: center;
    align-items: center;
  }
}

.step-3B__summary {
  margin-top: 10px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
  }
}
.summary-block__wrap {
  display: flex;
  flex-direction: column;
  .summary-field__row {
    display: flex;
    justify-content: space-between;
  }
  .summary-field__label {
    font-size: 12px;
    color: #343f4b;
  }
}
</style>
